/**
 * Display names of known Webflow MCP Bridge Apps (Designer Extensions).
 * Used server-side to detect MCP-originated requests and in the Designer to
 * produce `WEBFLOW_MCP` attribution headers.
 */
export const KNOWN_MCP_BRIDGE_NAMES: ReadonlySet<string> = new Set([
  'Webflow MCP Bridge App',
]);
